module.exports = __webpack_public_path__ + "img/bg_default.3e00c5fc.jpg";